import React from 'react';
import { Lock } from 'lucide-react';
export function FinalCTASection() {
  return <section className="relative w-full py-32 px-4 bg-navy overflow-hidden" data-id="element-66">
      {/* Radial golden glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-67"></div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-68">
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-8 font-medium" data-id="element-69">
          You've read this far for a reason.
        </p>

        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-cream leading-tight mb-8" data-id="element-70">
          The Frequency That's Been Blocking You
          <br className="hidden md:block" data-id="element-71" />
          <span className="italic" data-id="element-72">Has A Name. And Now You Can Clear It.</span>
        </h2>

        <p className="text-xl md:text-2xl text-rose font-serif italic mb-12 max-w-2xl" data-id="element-73">
          "Join 3,200+ women who chose to stop waiting for their luck to change
          — and changed their frequency instead."
        </p>

        <p className="text-cream/90 text-lg mb-8" data-id="element-74">
          One-time payment of only $6.37. Instant access. 7-Day Guarantee.
        </p>

        <a href="https://pay.hotmart.com/Q105372393V?checkoutMode=10" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="w-full md:w-auto inline-flex items-center justify-center px-10 py-6 bg-cta-red text-white font-bold text-xl md:text-2xl rounded-full animate-heartbeat hover:bg-red-700 transition-colors duration-300 mb-6" data-id="element-75">
          Clear My Frequency Now — $6.37 →
        </a>

        <div className="flex items-center justify-center space-x-2 text-gold font-medium text-xs md:text-sm" data-id="element-76">
          <Lock className="w-4 h-4" data-id="element-77" />
          <span data-id="element-78">
            Secure Checkout | Instant Digital Delivery | 7-Day Money Back
            Guarantee
          </span>
        </div>
      </div>
    </section>;
}